import { observable } from "mobx";
import { Type } from "class-transformer";
import SystemComponentOutageResponse from "./systemComponentOutageResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SystemComponentOutagesResponse {
  /**
   * The list of system component outages.
   */
  @observable
  @Type(() => SystemComponentOutageResponse)
  items!: SystemComponentOutageResponse[];
}
